import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import GroupsIcon from '@mui/icons-material/Groups';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import SpeedIcon from '@mui/icons-material/Speed';

const values = [
  {
    icon: BusinessIcon,
    title: 'Professional Excellence',
    description: 'We maintain the highest standards of professionalism in everything we do.',
  },
  {
    icon: GroupsIcon,
    title: 'Client-Centric',
    description: 'Our clients\' success is our success. We prioritize their needs and goals.',
  },
  {
    icon: LightbulbIcon,
    title: 'Innovation',
    description: 'We embrace new technologies and innovative solutions to solve complex problems.',
  },
  {
    icon: SpeedIcon,
    title: 'Agility',
    description: 'We adapt quickly to changes and deliver solutions efficiently.',
  },
];

const About = () => {
  return (
    <Box sx={{ py: 8 }}>
      {/* Hero Section */}
      <Box sx={{ bgcolor: 'primary.main', color: 'white', py: 6, mb: 8 }}>
        <Container maxWidth="lg">
          <Typography variant="h2" component="h1" sx={{ fontWeight: 700, mb: 2 }}>
            About Infysols
          </Typography>
          <Typography variant="h5" sx={{ opacity: 0.9, maxWidth: 800 }}>
            We are a team of passionate technologists dedicated to transforming businesses through innovative software solutions.
          </Typography>
        </Container>
      </Box>

      {/* Mission Section */}
      <Container maxWidth="lg">
        <Grid container spacing={8}>
          <Grid item xs={12} md={6}>
            <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: 600 }}>
              Our Mission
            </Typography>
            <Typography variant="body1" paragraph align="justify">
              At Infysols, we strive to empower businesses with cutting-edge software solutions that drive growth and innovation. Our mission is to be the catalyst for digital transformation, helping organizations thrive in an increasingly connected world.
            </Typography>
            <Typography variant="body1" paragraph align="justify">
              Founded in 2021, we've quickly established ourselves as a trusted partner for businesses seeking reliable and innovative software development services.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: 2,
              }}
            >
              <Box
                component="img"
                src="/images/logo/logo-light.png"
                alt="Infysols Logo"
                sx={{
                  maxWidth: '60%',
                  height: 'auto',
                  objectFit: 'contain',
                }}
              />
            </Box>
          </Grid>
        </Grid>

        {/* Values Section */}
        <Box sx={{ my: 8 }}>
          <Typography variant="h4" component="h2" align="center" sx={{ mb: 6, fontWeight: 600 }}>
            Our Values
          </Typography>
          <Grid container spacing={4}>
            {values.map((value, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card sx={{ height: '100%' }} elevation={2}>
                  <CardContent sx={{ textAlign: 'center' }}>
                    <value.icon sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
                    <Typography variant="h6" component="h3" gutterBottom>
                      {value.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" align="justify">
                      {value.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default About; 